export default __webpack_public_path__ + "static/media/airPods.4c099dc6.png";